import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import AcquisitionCard from './AcquisitionCard.jsx';
import ActivationCard from './ActivationCard';
import RetentionCard from './RetentionCard.jsx';
import RevenueCard from './RevenueCard.jsx';
import ReferralCard from './ReferralCard.jsx';
import styled from 'styled-components';

//import { fetchSubscribers, fetchBroadcasts } from '../utils/convertkitAPI';



import { allowedUserIds } from '../utils/analytics/allowedUserIds.jsx';
import { fetchSubscribers, fetchBroadcasts } from '../utils/analytics/ConvertKitAPI.js';


//These are for the AI Agent Stats 

import LearnWithAIUserTable from './components/LearnWithAIUserTable.jsx';
import AskChartUserTable from './components/AskChartUserTable.jsx';
import AhaMomentUserTable from './components/AhaMomentUserTable.jsx';

import { aiAgents } from './components/aiAgentsConfig.js';





const TabButton = styled.button`
  padding: 10px 16px;
  margin-right: 10px;
  border-radius: 12px;
  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  border: none;
  background-color: ${props => props.active ? '#FF7C24' : '#eee'};
  color: ${props => props.active ? 'white' : '#232830'};
  cursor: pointer;
  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.03);
  }
`;






const DashboardWrapper = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  padding: 2rem;
  background-color: #FFFFFF;
  color: #232830;
`;

const ControlsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const Select = styled.select`
  padding: 0.5rem;
  font-family: 'Nunito Sans', sans-serif;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const DateInput = styled.input`
  padding: 0.5rem;
  font-family: 'Nunito Sans', sans-serif;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const ErrorText = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  color: #FF7C24;
  margin-top: 2rem;
`;

const StatCard = styled.div`
  background: #FFFAF5;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const StatTitle = styled.h3`
  font-size: 18px;
  margin-bottom: 0.75rem;
  color: #232830;
`;

const StatText = styled.p`
  font-size: 16px;
  margin: 0.25rem 0;
  color: #232830;
`;

const AgentSection = styled.div`
  margin-top: 2rem;
  padding: 1.5rem;
  border-radius: 16px;
  background-color: #FFFCF9;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
`;

const AgentStatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
`;

const CollapseToggle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin: 1.5rem 0 1rem;
  padding: 10px 20px;
  border-radius: 12px;
  background-color: ${props => props.bg || '#E0F7FF'};
  cursor: pointer;
  display: inline-block;
  color: #232830;
  user-select: none;
`;




export default function PirateMetricsDashboard() {

  const [aiAhaMomentData, setAiAhaMomentData] = useState([]);


  const [activeTab, setActiveTab] = useState('learning'); // 'learning' or 'newsletter'

  const [showAskChartDetails, setShowAskChartDetails] = useState(false);

  const [aiAgentDataMap, setAiAgentDataMap] = useState({});
const [expandedSections, setExpandedSections] = useState({});


  const [userData, setUserData] = useState([]);
  const [activationData, setActivationData] = useState([]);
  const [revenueData, setRevenueData] = useState([]);
  const [loginAuditData, setLoginAuditData] = useState([]);
  const [referralData, setReferralData] = useState([]);
  const [aiAskChartData, setAiAskChartData] = useState([]);
  const [aiLearnData, setAiLearnData] = useState([]);

  const [daysRange, setDaysRange] = useState(7);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [error, setError] = useState('');


  //Newsletter

  const [newsletterStats, setNewsletterStats] = useState({
    subscribers: null,
    openRate: null,
    clickRate: null,
    emailsSent: null,
    unsubscribes: null,
  });

  useEffect(() => {
    const loadNewsletterStats = async () => {
      try {
        const totalSubscribers = await fetchSubscribers();
        const broadcasts = await fetchBroadcasts();
  
        const totalEmails = broadcasts.reduce((sum, b) => sum + (b.total_recipients || 0), 0);
        const totalOpens = broadcasts.reduce((sum, b) => sum + (b.total_unique_opens || 0), 0);
        const totalClicks = broadcasts.reduce((sum, b) => sum + (b.total_unique_clicks || 0), 0);
        const totalUnsubs = broadcasts.reduce((sum, b) => sum + (b.total_unsubscribes || 0), 0);
  
        setNewsletterStats({
          subscribers: totalSubscribers,
          emailsSent: totalEmails,
          openRate: totalEmails ? ((totalOpens / totalEmails) * 100).toFixed(1) + '%' : '0%',
          clickRate: totalEmails ? ((totalClicks / totalEmails) * 100).toFixed(1) + '%' : '0%',
          unsubscribes: totalUnsubs,
        });
      } catch (err) {
        console.error('Failed to load ConvertKit stats', err);
      }
    };
  
    if (activeTab === 'newsletter') {
      loadNewsletterStats();
    }
  }, [activeTab]);
  



  

  // 🔸 Full Section Wrapper
const [showLearnDetails, setShowLearnDetails] = useState(false);
const toggleLearnDetails = () => setShowLearnDetails(!showLearnDetails);

  const getRangeStartTimestamp = () => {
    if (fromDate && toDate) {
      return {
        from: Timestamp.fromDate(new Date(fromDate)),
        to: Timestamp.fromDate(new Date(toDate))
      };
    } else {
      const now = new Date();
      return {
        from: Timestamp.fromDate(new Date(now.setDate(now.getDate() - daysRange))),
        to: Timestamp.fromDate(new Date())
      };
    }
  };

  const validateInput = () => {
    if ((daysRange && fromDate && toDate)) {
      setError('⚠️ Please select either a number of days OR a date range, not both.');
      return false;
    }
    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      setError('⚠️ "From Date" must be earlier than or equal to "To Date".');
      return false;
    }
    if (!daysRange && (!fromDate || !toDate)) {
      setError('⚠️ Please select a valid time range.');
      return false;
    }
    setError('');
    return true;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!validateInput()) return;
      const { from, to } = getRangeStartTimestamp();

      const applyUserFilter = (docs) => docs.map(doc => doc.data()).filter(d => allowedUserIds.includes(d.userid));

      const userSnapshot = await getDocs(collection(db, 'users'));
      const users = userSnapshot.docs.map(doc => doc.data());
      
      const filteredUsers = users.filter(user => {
        if (!allowedUserIds.includes(user.userid)) return false;
      
        const rawDate = user.joineddate;
      
        let parsedDate;
        if (typeof rawDate === 'string') {
          // Handle iOS ISO-like format
          if (rawDate.includes('-') && rawDate.includes('+')) {
            parsedDate = new Date(rawDate);
          } 
          // Handle web human-readable format
          else if (rawDate.includes('at')) {
            const cleaned = rawDate.replace(' at', '');
            parsedDate = new Date(Date.parse(cleaned));
          }
        } else if (rawDate instanceof Timestamp) {
          parsedDate = rawDate.toDate();
        } else if (rawDate instanceof Date) {
          parsedDate = rawDate;
        }
      
        if (!parsedDate || isNaN(parsedDate)) return false;
        return parsedDate >= from.toDate() && parsedDate <= to.toDate();
      });
      
      setUserData(filteredUsers);
      

      const activationQuery = query(collection(db, 'userpracticesessions'), where('date', '>=', from), where('date', '<=', to));
      const activationSnapshot = await getDocs(activationQuery);
      setActivationData(applyUserFilter(activationSnapshot.docs));

      const revenueQuery = query(collection(db, 'subscriptions'), where('isactive', '==', '1'), where('date', '>=', from), where('date', '<=', to));
      const revenueSnapshot = await getDocs(revenueQuery);
      setRevenueData(applyUserFilter(revenueSnapshot.docs));

      const loginQuery = query(collection(db, 'userloginaudit'), where('date', '>=', from), where('date', '<=', to));
      const loginSnapshot = await getDocs(loginQuery);
      setLoginAuditData(applyUserFilter(loginSnapshot.docs));

      const referralQuery = query(collection(db, 'referrals'), where('date', '>=', from), where('date', '<=', to));
      const referralSnapshot = await getDocs(referralQuery);
      setReferralData(applyUserFilter(referralSnapshot.docs));

      // const askChartQuery = query(collection(db, 'user_aiagent_ask_the_chart_interactions'), where('timestamp', '>=', from), where('timestamp', '<=', to));
      // const askChartSnapshot = await getDocs(askChartQuery);
      // setAiAskChartData(applyUserFilter(askChartSnapshot.docs));

      // const learnAIQuery = query(collection(db, 'user_aiagent_learn_with_ai_interactions'), where('timestamp', '>=', from), where('timestamp', '<=', to));
      // const learnAISnapshot = await getDocs(learnAIQuery);
      // setAiLearnData(applyUserFilter(learnAISnapshot.docs));

      

      const agentDataMap = {};

      const ahaQuery = query(
        collection(db, 'user_learn_aha_moment_ai_interactions'),
        where('timestamp', '>=', from),
        where('timestamp', '<=', to)
      );
      const ahaSnapshot = await getDocs(ahaQuery);
      setAiAhaMomentData(applyUserFilter(ahaSnapshot.docs, true)); // `true` allows anonymous
      

for (const agent of aiAgents) {
  const agentQuery = query(
    collection(db, agent.firestoreCollection),
    where('timestamp', '>=', from),
    where('timestamp', '<=', to)
  );
  const snapshot = await getDocs(agentQuery);
  agentDataMap[agent.id] = applyUserFilter(snapshot.docs);
}

setAiAgentDataMap(agentDataMap);

    };

    fetchData();
  }, [daysRange, fromDate, toDate]);

  const countMessages = (data) => data?.length || 0;
const countUniqueUsers = (data) => new Set(data?.map(d => d.userid)).size;

const toggleExpanded = (id) => {
  setExpandedSections(prev => ({ ...prev, [id]: !prev[id] }));
};

const isExpanded = (id) => !!expandedSections[id];


return (

  
  <DashboardWrapper>
    {/* Tab Buttons */}
    <div style={{ marginBottom: '1rem' }}>
      {/* <button
        onClick={() => setActiveTab('learning')}
        style={{
          padding: '10px 16px',
          marginRight: '10px',
          borderRadius: '10px',
          border: 'none',
          fontWeight: 'bold',
          backgroundColor: activeTab === 'learning' ? '#FF7C24' : '#eee',
          color: activeTab === 'learning' ? 'white' : '#232830',
          cursor: 'pointer',
        }}
      >
        📚 Learning Metrics
      </button> */}

      <TabButton onClick={() => setActiveTab('learning')} active={activeTab === 'learning'}>
  📚 Learning Metrics
</TabButton>

      {/* <button
        onClick={() => setActiveTab('newsletter')}
        style={{
          padding: '10px 16px',
          borderRadius: '10px',
          border: 'none',
          fontWeight: 'bold',
          backgroundColor: activeTab === 'newsletter' ? '#FF7C24' : '#eee',
          color: activeTab === 'newsletter' ? 'white' : '#232830',
          cursor: 'pointer',
        }}
      >
        📬 Newsletter (ConvertKit)
      </button> */}

<TabButton onClick={() => setActiveTab('newsletter')} active={activeTab === 'newsletter'}>
📬 Newsletter (ConvertKit)
</TabButton>




      {/* <button
        onClick={() => setActiveTab('billing')}
        style={{
          padding: '10px 16px',
          borderRadius: '10px',
          border: 'none',
          fontWeight: 'bold',
          backgroundColor: activeTab === 'newsletter' ? '#FF7C24' : '#eee',
          color: activeTab === 'newsletter' ? 'white' : '#232830',
          cursor: 'pointer',
        }}
      >
        📬 Billing Metrics (SaaS Costs)
      </button> */}

<TabButton onClick={() => setActiveTab('billing')} active={activeTab === 'billing'}>
📬 AI Billing
</TabButton>

<TabButton onClick={() => setActiveTab('googleanalytics')} active={activeTab === 'googleanalytics'}>
📬 Google Analytics
</TabButton>

<TabButton onClick={() => setActiveTab('financialmodel')} active={activeTab === 'financialmodel'}>
📬 Financial Model
</TabButton>




    </div>

    {/* 👇 Learning Metrics View */}
    {activeTab === 'learning' && (
      <>
        <ControlsWrapper>
          <Select value={daysRange} onChange={(e) => setDaysRange(Number(e.target.value))}>
            <option value="">-- Select Number of Days --</option>
            {[1, 7, 14, 30, 90, 180, 365].map(day => (
              <option key={day} value={day}>
                Last {day} Day{day > 1 ? 's' : ''}
              </option>
            ))}
          </Select>

          <StatText>
Note : Are stats 0 for a time period. Make sure to update the allowed UserId's in the timesheet
</StatText>
          <DateInput type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          <DateInput type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
           
    


 

<StatText>
<a href="https://docs.google.com/spreadsheets/d/1TMk51ZGnCgesvOunQ4oY1Yd2Cu9zyZhR9BgakMVnuCk/edit?gid=773469474#gid=773469474
">GoogleSheet UserID's  - Copy paste from Firebase Console</a> 
</StatText>



<StatText>
<a href="https://analytics.google.com/analytics/web/#/a192872118p348258325/admin/streams/table/4399621312
">Google Analytics</a>
</StatText>


<StatText>
<a href="https://fintorro.atlassian.net/wiki/x/nIAVC
">FinTorro Google Analytics Playbook</a>
</StatText>





<StatText>
          <a href="https://console.firebase.google.com/u/0/project/tradingfunda-4376a/authentication/users" target="_blank" rel="noopener noreferrer">
            Firebase Console
          </a>
</StatText>







<a href=" "> Update allowedUserID's.txt to make it accurate - chatpgpt prompt in comments of the source file  </a>


{/* {Chatgpt prompt to generate the ids to copy into allowedUserId's files */}
 {/* /* can you update below id's to be as below i.e make them command separated and also each id surrounded by '' - for example below 

example below 

'Yr3VP68lEGOKffnWdS7GsZowF2m1',
'hw7sVWDO8WQOW8As2UGJNceMwfn2',


id's to update 

Copy ids from the spreadsheet above */} 





        </ControlsWrapper>

        {error && <ErrorText>{error}</ErrorText>}

        <Grid>
          <AcquisitionCard userData={userData} />
          <ActivationCard practiceSessions={activationData} />
          <RetentionCard loginAuditData={loginAuditData} />
          <RevenueCard revenueData={revenueData} />
          <ReferralCard referralData={referralData} />

        </Grid>

        <AgentSection>
          <SectionTitle style={{ marginTop: 0 }}>🤖 AI Agents Overview  - todo user_ask_the_chart_symbols -----  Use in the Analytics </SectionTitle>

          <AgentStatGrid>
            {aiAgents.map(agent => (
              <StatCard key={agent.id}>
                <StatTitle>{agent.label}</StatTitle>
                <StatText>Messages: {countMessages(aiAgentDataMap[agent.id])}</StatText>
                <StatText>Unique Users: {countUniqueUsers(aiAgentDataMap[agent.id])}</StatText>
                <StatText>Total Tokens</StatText>


                
              </StatCard>
            ))}
          </AgentStatGrid>

          {aiAgents.map(agent => {
            const Component = agent.component;
            const data = aiAgentDataMap[agent.id] || [];

            return (
              <React.Fragment key={agent.id}>
                <CollapseToggle onClick={() => toggleExpanded(agent.id)} bg={agent.bg}>
                  {isExpanded(agent.id) ? '🔽' : '▶️'} {agent.label} — Message Details (Grouped by User)
                </CollapseToggle>
                {isExpanded(agent.id) && (
                  <div style={{ marginTop: '1rem' }}>
                    {/* {Object.entries(
                      data.reduce((grouped, entry) => {
                        const uid = entry.userid;
                        if (!grouped[uid]) grouped[uid] = [];
                        grouped[uid].push(entry);
                        return grouped;
                      }, {})
                    ).map(([userid, entries]) => (
                      <Component key={userid} userid={userid} entries={entries} />
                    ))} */}

{Object.entries(
  data
    .sort((a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0)) // ✅ sort DESC
    .reduce((grouped, entry) => {
      const uid = entry.userid || 'anonymous';
      if (!grouped[uid]) grouped[uid] = [];
      grouped[uid].push(entry);
      return grouped;
    }, {})
).map(([userid, entries]) => (
  <Component key={userid} userid={userid} entries={entries} />
))}

                  </div>
                )}
              </React.Fragment>
            );
          })}
        </AgentSection>


      </>
    )}

    {/* 👇 Newsletter Metrics View */}
    {activeTab === 'newsletter' && (
  <div style={{ marginTop: '1.5rem' }}>
    <SectionTitle>📬 Newsletter Metrics (ConvertKit)</SectionTitle>

    <StatText> <a href="https://app.kit.com/campaigns">Campaigns</a> 
</StatText>

<StatText> <a href="https://app.kit.com/subscribers">Subscribers</a> 
</StatText>






    <Grid style={{ marginTop: '1rem' }}>
      <StatCard>
        <StatTitle>Subscribers</StatTitle>
        <StatText>{newsletterStats.subscribers ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Open Rate</StatTitle>
        <StatText>{newsletterStats.openRate ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Click Rate</StatTitle>
        <StatText>{newsletterStats.clickRate ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Emails Sent</StatTitle>
        <StatText>{newsletterStats.emailsSent ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Unsubscribes</StatTitle>
        <StatText>{newsletterStats.unsubscribes ?? 'Loading...'}</StatText>
      </StatCard>
    </Grid>
  </div>
)}


{/* 👇 Financial Model active tab */}
{activeTab === 'financialmodel' && (
  <div style={{ marginTop: '1.5rem' }}>
    <SectionTitle>📬 Financial Model Metrics </SectionTitle>
    <StatText> <a href="https://docs.google.com/spreadsheets/d/1koARM4AnLv8XS_RD2_0KwHIHOkQvxRt9iu_UngEd5jw/edit?gid=1724652374#gid=1724652374">Financial Model Spreadsheet </a> 
</StatText>

<StatText> <a href="">Budget</a> 
</StatText>






    <Grid style={{ marginTop: '1rem' }}>
      <StatCard>
        <StatTitle>Budget</StatTitle>
        <StatText>{newsletterStats.subscribers ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Revenue</StatTitle>
        <StatText>{newsletterStats.openRate ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Profits</StatTitle>
        <StatText>{newsletterStats.clickRate ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Burn Rate</StatTitle>
        <StatText>{newsletterStats.emailsSent ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Others</StatTitle>
        <StatText>{newsletterStats.unsubscribes ?? 'Loading...'}</StatText>
      </StatCard>
    </Grid>
  </div>
)}







{/* 👇 Billing Metrics View */}
{activeTab === 'billing' && (
  <div style={{ marginTop: '1.5rem' }}>
    <SectionTitle>📬SaaS Costs</SectionTitle>

    <Grid style={{ marginTop: '1rem' }}>

    <StatCard>
        <StatTitle>AI Billing</StatTitle>
        <StatText>Gemini  https://aistudio.google.com/usage?project=fintorro-website</StatText>
        <StatText>Pricing :  <a href="https://ai.google.dev/gemini-api/docs/pricing"> Gemini Pricing </a> </StatText>
        <StatText>Pricing :  <a href="https://platform.openai.com/settings/organization/usage"> OpenAI Usage </a> </StatText>
        <StatText>DeepSeek Usage :  <a href="https://platform.openai.com/settings/organization/usage"> DeepSeek Usage </a> </StatText>
        <StatText>Lllama Usage :  <a href="https://platform.openai.com/settings/organization/usage"> Llama Usage </a> </StatText>
        



      </StatCard>
      <StatCard>
        <StatTitle>Cloud Billing</StatTitle>

       
       
        <StatText>Google Cloud :  <a href="https://console.cloud.google.com/billing/0161E4-E84765-043AD2/manage?inv=1&invt=Ab1CN"> Gemini Pricing </a> </StatText>


        <StatText>{newsletterStats.subscribers ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Dreamhost</StatTitle>
        <StatText>{newsletterStats.openRate ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>ConvertKit</StatTitle>
        <StatText>{newsletterStats.clickRate ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Zapier</StatTitle>
        <StatText>{newsletterStats.emailsSent ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>
        <StatTitle>Domains </StatTitle>
        <StatText>{newsletterStats.emailsSent ?? 'Loading...'}</StatText>
      </StatCard>
      <StatCard>

      <StatCard>
        <StatTitle>Midjourney</StatTitle>
        <StatText><a href="https://www.midjourney.com/account"> Monthly 22nd Nov   </a>   </StatText>
      </StatCard> 



        <StatTitle>TypeForm</StatTitle>
        
        
        <StatText>Godaddy - 1 Account :  <a href="https://cart.godaddy.com/go/checkout#/">Godaddy - 1 Account </a></StatText>
        <StatText>Godaddy - 2nd Account <a href="https://cart.godaddy.com/go/checkout#/">Godaddy - 2 Account </a> </StatText>
        <StatText>Deamhost Domains <a href="https://dreamhost.com/">Dreamhost domains </a> </StatText>
      </StatCard>
    </Grid>
  </div>
)}

    {/* 👇 Google Analytics Metrics View */}
{activeTab === 'googleanalytics' && (
  <div style={{ marginTop: '1.5rem' }}>
    <SectionTitle>📬 Google Analytics & Tag Manager</SectionTitle>

    <Grid style={{ marginTop: '1rem' }}>
      <StatCard>
        <StatTitle>🌐 GA4 Dashboard – FinTorro Website</StatTitle>
        <StatText>
          <a href="https://analytics.google.com/analytics/web/#/p348258325/reports/intelligenthome" target="_blank" rel="noopener noreferrer">
            View GA4 Dashboard
          </a>
        </StatText>
        <StatText>
          <a href="https://analytics.google.com/analytics/web/#/a192872118p348258325/admin/streams/table/4399621312" target="_blank" rel="noopener noreferrer">
            Web Stream Settings
          </a>
        </StatText>
        <StatText>
          <a href="https://tagmanager.google.com/#/container/accounts/192872118/containers/43355141/workspaces" target="_blank" rel="noopener noreferrer">
            Google Tag Manager (Web)
          </a>
        </StatText>
      </StatCard>

      <StatCard>
        <StatTitle>📱 GA4 Dashboard – FinTorro iOS App</StatTitle>
        <StatText>
          <a href="https://analytics.google.com/analytics/web/#/a192872118p348258325/admin/streams/table" target="_blank" rel="noopener noreferrer">
            Mobile Stream Settings
          </a>
        </StatText>
        <StatText>
          <a href="https://firebase.google.com/docs/analytics" target="_blank" rel="noopener noreferrer">
            Firebase iOS Analytics Docs
          </a>
        </StatText>
        <StatText>
          <a href="https://console.firebase.google.com/project/fintorro-website/analytics/app" target="_blank" rel="noopener noreferrer">
            Firebase Analytics Dashboard
          </a>
        </StatText>

        <StatText>
          <a href="https://console.firebase.google.com/u/0/project/tradingfunda-4376a/authentication/users" target="_blank" rel="noopener noreferrer">
            Firebase Console
          </a>
       </StatText>



      </StatCard>

      <StatCard>
        <StatTitle>🧪 Debug & Testing Tools</StatTitle>
        <StatText>
          <a href="https://ga-dev-tools.web.app/ga4/event-builder/" target="_blank" rel="noopener noreferrer">
            GA4 Event Builder
          </a>
        </StatText>
        <StatText>
          <a href="https://tagassistant.google.com/" target="_blank" rel="noopener noreferrer">
            Google Tag Assistant
          </a>
        </StatText>
        <StatText>
          <a href="chrome://extensions/?id=jeoacafpbcihiomhlakheieifhpjdfeo" target="_blank" rel="noopener noreferrer">
            GA Debugger Chrome Extension
          </a>
        </StatText>
      </StatCard>

      <StatCard>
        <StatTitle>📊 Reports & Conversions</StatTitle>
        <StatText>
          <a href="https://analytics.google.com/analytics/web/#/p348258325/reports/conversions-events" target="_blank" rel="noopener noreferrer">
            Conversion Events
          </a>
        </StatText>
        <StatText>
          <a href="https://analytics.google.com/analytics/web/#/p348258325/reports/explorer?params=_u..nav%3Dmaui&collectionId=life-cycle" target="_blank" rel="noopener noreferrer">
            Funnel Reports
          </a>
        </StatText>
        <StatText>
          <a href="https://analytics.google.com/analytics/web/#/p348258325/reports/explorer?params=_u..nav%3Dmaui&collectionId=user" target="_blank" rel="noopener noreferrer">
            User Lifetime View
          </a>
        </StatText>
      </StatCard>
    </Grid>
  </div>
)}




  </DashboardWrapper>
);

}